<div class='record-container'>

  <h2 class='title-min-size'> Graduatorie speciali </h2>

  <div class='container'>

    <div class='m-b-10 m-t-10'>

      <app-special-rankings-filters #filters (update)='fetch()'></app-special-rankings-filters>

    </div>

    <ct-datatable
      *ngIf='specialRankings'
      [configuration]='specialRankings'
      (reload)='fetch($event)'></ct-datatable>

  </div>

</div>

<ng-template #rankingTemplate let-row='row' let-value='value' let-i='index'>

  <div>

    <div>
      {{ row['SPNUserInfoName'] ?? '' }} {{ row['SPNUserInfoSurname'] ?? '' }}
      <small>({{ getCategoryLabel(row['AthleteCategoryCategory']) }})</small>
    </div>

    <div><small><i>{{ row['TimeDate'] | date }}</i> | {{ row['SPNEventProductProductDescription'] ?? '' }}</small></div>

  </div>

</ng-template>

<ng-template #descriptionTemplate let-row='row' let-value='value' let-i='index'>

  <div>

    <div><strong> {{ row['RaceSpecialtySwimStyleName'] ?? '' }} {{ row['RaceSpecialtyDistance'] ?? '' }}</strong></div>
    <div><strong> TG: {{ row['TimeForGrid'] | splittedTimeFormat }}</strong></div>

  </div>

</ng-template>
